<template>
    
    <b-modal ref="my-account-modal" id="my-account-modal" title="My Account" hide-footer>

        <p>Email: {{clientInfo.clientEmail}}</p>
        <p>Account Type: {{clientInfo.clientAccount}}</p>
        <p v-if="clientInfo.clientAccount == 'PRO'">Activation Code: {{clientInfo.clientActivationCode}}</p>
        <p v-if="clientInfo.clientAccount == 'PRO'">Sites used on: {{clientInfo.clientSitesUsedOn}}/{{clientInfo.clientSitesAmountAllowed}}</p>
        <p v-if="clientInfo.clientAccount != 'PRO'"><b-button v-b-modal="'upgrades-modal'">Upgrade Account</b-button></p>
        <p v-if="clientInfo.clientAccount != 'PRO'" @click="showActivationInput = true" class="showactivationbtn">Already own activation code?</p>
        
        <div v-if="showActivationInput">
            <b-form inline>
                <label class="sr-only" for="inline-form-input-name">Add activation code:</label>
                <b-input
                id="inline-form-input-name"
                class="mb-2 mr-sm-2 mb-sm-0"
                placeholder="Code"
                v-model="redeemCodeInput"
                ></b-input>
                
                <b-button variant="primary" size="sm" @click="addRedeemCode">Activate</b-button>
            </b-form>
        </div>

        <div class="loading-overlay" v-if="validatingRedeemCode">
            
            <div class="spinner-save">
                <b-spinner variant="primary" label="Saving" />
                <div class="spinner-save-text">
                    Validating
                </div>
            </div>
                
        </div>
    
    </b-modal>

</template>

<script>
import axios from 'axios'
export default {

    name: 'MyAccount',

    data() {
        return {
            siteToken: this.$store.state.jwtToken,
            showActivationInput: false,
            redeemCodeInput: '',
            validatingRedeemCode: false
        }
    },
    methods: {

        reRequestIt() {
            let fd = new FormData();
            let jwtToken = function findGetParameter() {
                var result = null,
                    tmp = [];
                location.search
                    .substr(1)
                    .split("&")
                    .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === 'jwt') result = decodeURIComponent(tmp[1]);
                    });
                return result;
            }
            this.$store.state.jwtToken = jwtToken()

            fd.append('jwt-token', this.$store.state.jwtToken)
            
            axios.post('https://www.appjustable.com/weebly/app_in_process/buttons/user_info.php',fd)
            .then((response)=> {
                console.log(response)
                this.$store.state.googleFontsToLoad = response.data.fonts

                this.$store.state.clientInfo.clientEmail = response.data.email

                this.$store.state.clientInfo.clientAccount = response.data.account_type

                this.$store.state.clientInfo.clientActivationCode = response.data.activation_code

                this.$store.state.clientInfo.clientSitesAmountAllowed = response.data.account_licenses

                this.$store.state.clientInfo.clientSitesUsedOn = response.data.sites.length


            }).catch( (error)=> {
                console.log(error)
            })
        },

        addRedeemCode() {
            this.validatingRedeemCode = true
            let fd = new FormData();
            
            fd.append('activation_code', this.redeemCodeInput)
            fd.append('jwt-token', this.$store.state.jwtToken)
            
            axios.post('https://www.appjustable.com/weebly/app_in_process/buttons/redeem.php',fd)
            .then((response)=> {
                console.log(response)
                this.reRequestIt()
                this.$refs['my-account-modal'].hide()
                setTimeout(()=>{
                    this.validatingRedeemCode = false
                },2000)
                
            }).catch( (error)=> {
                console.log(error)
                setTimeout(()=>{
                    this.validatingRedeemCode = false
                },2000)
            })
        }
    },

    computed: {
        clientInfo() {
            return this.$store.state.clientInfo
        }
    }

}
</script>

<style lang="less">
.showactivationbtn {
    cursor: pointer;
    &:hover {
        opacity: .8;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccount.vue